import { GridSortModel } from "@mui/x-data-grid";

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PRODUCT_ID_SORT = {
  field: "product_id",
  direction: "DESC",
};

export const DEFAULT_BACKEND_SORTS = [
  { field: "intensity", direction: "DESC" },
  DEFAULT_PRODUCT_ID_SORT,
];
export const DEFAULT_SORT_MODEL: GridSortModel = [
  { field: "intensity", sort: "desc" },
];
